require('./reports-settings.component.scss');

export const ReportsSettingsModalController = function(
  $scope,
  $modalInstance,
  $http,
  PermissionService,
  data,
  $cookies,
) {
  $scope.cancel = () => $modalInstance.dismiss('cancel');
  $scope.$http = $http;
  $scope.reports = data.reports;
  $scope.users = data.users;
  $scope.getUserName = user => user.name + (user.fullName ? ` (${user.fullName})` : '');
  $scope.common = [];
  $scope.fields = [];

  const getReportId = (url, reports) => {
    if (!url) return '';
    const report = angular.copy(reports).sort((a, b) => a.id > b.id ? -1 : 1).find(r => url.startsWith(r.id));
    return report ? report.id : '';
  };

  $scope.data = {
    report: getReportId(data.report, data.reports),
    user: PermissionService.userName,
  };
  $scope.reportName = '';
  $scope.userName = '';
  $scope.error = null;

  $scope.inputType = type => {
    if (type === 'time') return 'time';
    if (type === 'boolean') return 'checkbox';
    if (type === 'number') return 'number';
    return 'text';
  };

  $scope.getParamById = id => {
    return $scope.common.find(p => p.id == id);
  };

  const objToArry = (obj, func) => Object.keys(obj)
    .sort()
    .map(k => Object.assign({
      id: k
    }, obj[k]));

  const setParams = (params, error) => {
    if (params) {
      $scope.common = objToArry(params.common);

      $scope.evalParams = {};

      $scope.common.forEach((param) => {
        Object.defineProperty($scope.evalParams, param.id, {
          get: () => $scope.getParamById(param.id).value
        });
      });

      $scope.common.forEach((param) => {
        if (typeof param.condition == 'string') {
          param.condition_expr = param.condition;
          Object.defineProperty(param, 'disabled', {
            get: function() {
              return !$scope.$eval(this.condition_expr, $scope.evalParams);
            }
          });
        } else {
          param.disabled = false;
        }
      });

      $scope.fields = objToArry(params.fields);
      $scope.showFieldsFormat = $scope.fields.some(f => f.format);
    } else {
      $scope.common = [];
      $scope.fields = [];
    }
    if (error) $scope.error = error;
    else $scope.error = null;
  };

  const arrToObj = arr => {
    return arr.reduce((obj, item) => {
      const newItem = {
        id: item.id
      };
      if (item.value !== undefined) {
        newItem.value = item.value;
      }
      if (item.hide !== undefined) {
        newItem.hide = item.hide;
      }
      obj[item.id] = newItem;
      return obj;
    }, {});
  };

  $scope.getParams = () => {
    if (!$scope.data.report || !$scope.data.user) return;
    $scope.reportName = $scope.reports.find(r => r.id === $scope.data.report)['name'];
    $scope.userName = $scope.getUserName($scope.users.find(u => u.name === $scope.data.user));
    $scope.$http.post('/analytics/obtain_reports_settings/', $scope.data, {
        headers: {
          'X-CSRFToken': $cookies.get('csrftoken'),
        }
      })
      .then(({
        data: {
          params,
          error,
        },
        status,
      }) => {
        setParams(params, error);
      });
  };

  $scope.save = (isClose = false) => {
    if (!$scope.data.report || !$scope.data.user) return;
    const newParams = {
      common: arrToObj($scope.common),
      fields: arrToObj($scope.fields),
    };
    const postValue = Object.assign($scope.data, {
      params: newParams
    });
    $scope.$http.post('/analytics/save_reports_settings/', postValue, {
        headers: {
          'X-CSRFToken': $cookies.get('csrftoken'),
        }
      })
      .then(({
        data: {
          params,
          error,
        },
        status,
      }) => {
        setParams(params, error);
        window.CACHE.reset();
        $scope.$root.$broadcast('reload');
        if (isClose) $modalInstance.close('saved');
      });
  };

  $scope.reset = () => {
    if (!$scope.data.report || !$scope.data.user) return;
    $scope.$http.post('/analytics/obtain_default_reports_settings/', $scope.data, {
        headers: {
          'X-CSRFToken': $cookies.get('csrftoken'),
        }
      })
      .then(({
        data: {
          params,
          error,
        },
        status,
      }) => {
        setParams(params, error);
      });
  };
  $scope.getParams();
};



// WEBPACK FOOTER //
// ./src/core/reports-settings/reports-settings.component.js